var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'btn-desktop' : 'btn-mobile',attrs:{"color":"primary","disabled":_vm.desabilitarBtn,"data-cy":'btn_prosseguir_passo_' + _vm.index},on:{"click":_vm.setProximo}},[_vm._v("\n  Prosseguir\n")])}
var staticRenderFns = []

export { render, staticRenderFns }